/**
 * Copyright (c) 2019 Vendor Badge, LLC All Rights Reserved.
 * Created Date: Monday, 18th February 2019
 *
 *  Portal Views Header
 */
import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import { withStyles } from '@material-ui/core/styles';
import SubscribeNotifier from 'components/Notifications/SubscribeNotifier';
import { useStores } from 'stores/RootStore';
import { firebase } from 'containers/services/Firebase';

const ViewHeader = props => {
  const { classes } = props;
  const stores = useStores();
  const { isSubscribed } = stores.authStore;
  const { user } = stores.userStore;

  return (
    <React.Fragment>
      {user.type === 'Vendor' && !isSubscribed ? (
        <SubscribeNotifier
          open={true}
          messagePrefix={`Don't miss out! `}
          message={`In order to take full advantage of our services, subscribe now.`}
          variant={'error'}
          className={classes.notify}
          actionButtonClick={firebase.sendVendorWelcomeEmail}
        />
      ) : null}
    </React.Fragment>
  );
};

ViewHeader.propTypes = {
  classes: PropTypes.object.isRequired,
};

const styles = theme => ({
  notify: {
    marginTop: '5px',
    marginBottom: '20px',
  },
});

export default withStyles(styles, { withTheme: true })(observer(ViewHeader));
